export default __webpack_public_path__ + "static/media/2.665c48f2.png";